export type KoormaDirectionId =
  | "central"
  | "north"
  | "northeast"
  | "east"
  | "southeast"
  | "south"
  | "southwest"
  | "west"
  | "northwest";

const ALIASES: Record<string, KoormaDirectionId> = {
  centre: "central",
  center: "central",
  central: "central",
  nabhi: "central",
  navel: "central",

  n: "north",
  north: "north",

  ne: "northeast",
  northeast: "northeast",

  e: "east",
  east: "east",

  se: "southeast",
  southeast: "southeast",

  s: "south",
  south: "south",

  sw: "southwest",
  southwest: "southwest",

  w: "west",
  west: "west",

  nw: "northwest",
  northwest: "northwest",
};

export function normalizeDirectionKey(raw: string): string {
  const key = String(raw || "")
    .replace(/[^a-zA-Z]/g, "")
    .toLowerCase();
  return ALIASES[key] ?? key;
}

export function toKoormaDirectionId(raw: string): KoormaDirectionId | null {
  const normalized = normalizeDirectionKey(raw);
  return (ALIASES[normalized] ?? null) as KoormaDirectionId | null;
}

export type RiskSeverity = "high" | "medium" | "low";

export function riskSeverity(score: number): RiskSeverity {
  const s = Number.isFinite(score) ? score : 0;
  if (s >= 50) return "high";
  if (s >= 30) return "medium";
  return "low";
}
